export const PARTICIPANT_BASE_KEY = 'participants';

export const participantsApiQueryKeys = {
  all: () => [PARTICIPANT_BASE_KEY] as const,
  byId: (participantId: string) =>
    [PARTICIPANT_BASE_KEY, participantId] as const,
  details: (participantId: string) =>
    [PARTICIPANT_BASE_KEY, participantId, 'details'] as const,
};
